export enum SubscriptionStatus {
  SUBSCRIPTION_PRE_ACTIVE = 'SUBSCRIPTION_PRE_ACTIVE',
  SUBSCRIPTION_BLOCKED = 'SUBSCRIPTION_BLOCKED',
  SUBSCRIPTION_ACTIVE = 'SUBSCRIPTION_ACTIVE',
  SUBSCRIPTION_PAUSED = 'SUBSCRIPTION_PAUSED',
  SUBSCRIPTION_CANCELED = 'SUBSCRIPTION_CANCELED',
  SUBSCRIPTION_TERMINATED = 'SUBSCRIPTION_TERMINATED',
}
